import { CustomText } from '@/components/text/Texts';
import { Link } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';

const LoginLink = () => {
	return (
		<Link className="flex ml-3 my-2 items-center" to="/login">
			<MdArrowBack size={18} className="text-primary" />
			<CustomText
				text="Back to Log In"
				className="font-poppins font-medium text-label-large text-primary ml-2"
			/>
		</Link>
	);
};

export default LoginLink;
